import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import VerifyOtp from "../pages/VerifyOtp";
import CreateNewPassword from "../pages/CreateNewPassword";

import Home from "../pages/Home";

import Layout from "../layouts/Layout";

import Dashboard from "../pages/Dashboard";
import Profile from "../pages/Profile";
import VideoCall from "../components/VideoCall";

function AppRoutes() {
  return (
    <Router>
      <Routes>
        {/* Without Navbar */}
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/create-new-password" element={<CreateNewPassword />} />

        {/* With Navbar */}
        <Route
          path="/home"
          element={
            <Layout>
              <Home />
            </Layout>
          }
        />
        <Route
          path="/dashboard"
          element={
            <Layout>
              <Dashboard />
            </Layout>
          }
        />
        <Route
          path="/profile"
          element={
            <Layout>
              <Profile />
            </Layout>
          }
        />
        <Route path="/video-call" element={<VideoCall />} />
      </Routes>
    </Router>
  );
}

export default AppRoutes;
